// client/src/helpers/interestsTaxonomy.ts
//
// TRIL-116: convert underscored Interests enum keys ('AI_ML') to human
// display form ('AI ML'). The enum values are normalized to match keys
// (matching server-side); humanize is the render-time presentation step.

export function humanize(value: string): string {
  return value.replace(/_/g, ' ');
}
